/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raffle_TitleInputs */



/**
* | output |
* | --- |
* | "Raffle" |
*
* @param {Raffle_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_title = /** @type {((inputs?: Raffle_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tirage au sort")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sorteo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sorteio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Estrazione")
	return /** @type {LocalizedString} */ ("Raffle")
});